import { render } from "./UsersListTable.vue?vue&type=template&id=4d3a17f0"
import script from "./UsersListTable.vue?vue&type=script&lang=js"
export * from "./UsersListTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__